import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import Routes from '../constants/routes';
import { FAVORITE_GET } from '../reducers/favorite';
import useWishlist from '../services/wishlist/use-wishlist';
import session from '../utils/session';
import useCurrentPathMatch from './use-current-path-match';

// TEMPORARY — FE-254 Stage 1 bridge. React Query owns the wishlist fetch, but the
// state.main.favorite readers are migrated in FE-256, so mirror the query result into
// Redux until then. Remove this file (and the FAVORITE_GET action) in FE-256. Wishlist
// endpoints are forbidden on the payment page, so gate the query with `enabled` there
// to avoid a blocked request / retry loop.
const PAYMENT_PATHS = [Routes.PAYMENT.path];

type WishlistBridgeProps = { enabled?: boolean };

export const useWishlistReduxBridge = ({ enabled = true }: WishlistBridgeProps = {}) => {
    const dispatch = useDispatch<Dispatch>();
    const isPaymentPage = useCurrentPathMatch(PAYMENT_PATHS);
    const isLoggedIn = session.isLoggedIn();
    const isEnabled = enabled && !isPaymentPage;

    const { ids, total, isSuccess } = useWishlist({ isLoggedIn, enabled: isEnabled });

    const shouldSkipDispatch = !isEnabled || !isSuccess;

    useEffect(() => {
        if (shouldSkipDispatch) {
            return;
        }

        dispatch({
            type: FAVORITE_GET,
            list: ids.map((id) => ({ id })),
            total,
            loaded: true
        });
    }, [dispatch, ids, total, shouldSkipDispatch]);
};
